import React from "react";

import Number, { NumberProps } from "./Number";

type AutoNumberProps = Pick<
  NumberProps,
  | "value"
  | "multiply"
  | "prefix"
  | "suffix"
  | "minDecimals"
  | "maxDecimals"
  | "significantDigits"
> & {
  noDecimals?: boolean;
};

const AutoNumber: React.FC<AutoNumberProps> = ({ noDecimals, ...props }) => {
  const decimalConfig = noDecimals
    ? { minDecimals: 0, maxDecimals: 0, significantDigits: 0 }
    : {
        minDecimals: props.minDecimals || 2,
        maxDecimals: props.maxDecimals || 2,
        significantDigits: props.significantDigits || 2,
      };

  return <Number {...props} {...decimalConfig} />;
};

export default AutoNumber;
